export default "__VITE_ASSET___Mmmy$TU__"